var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowinline = function SvgArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.929 3.165 5.486 15.762h26.951v2.293H5.483L17.93 30.717l.357.364-.37.35-.89.84-.357.337-.343-.35-14.746-15-.345-.35.345-.35 14.746-15 .356-.363.357.363.89.905.345.351-.346.35Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
export default SvgArrowinline;